var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 12.175C14.0516 12.175 15.6172 10.5702 15.6172 8.5875C15.6172 6.60477 14.0516 5 12.1172 5C10.1828 5 8.61719 6.60477 8.61719 8.5875C8.61719 10.5702 10.1828 12.175 12.1172 12.175ZM14.5172 13.2H14.2578C13.6078 13.5203 12.8859 13.7125 12.1172 13.7125C11.3484 13.7125 10.6297 13.5203 9.97656 13.2H9.71719C7.72969 13.2 6.11719 14.8528 6.11719 16.89V17.8125C6.11719 18.6613 6.78906 19.35 7.61719 19.35H16.6172C17.4453 19.35 18.1172 18.6613 18.1172 17.8125V16.89C18.1172 14.8528 16.5047 13.2 14.5172 13.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/Individual.1d99d8ff1ab7a89a73c1d977ef1f6a3f.svg";
export { ForwardRef as ReactComponent };